import { any, number, array, object, string, literal } from "zod"
import { removeSeparator } from "utils/numberUtils"

export const wishItemCommentSchema = object({
  content: string().min(1)
})

export const wishItemRequestSchema = object({
  name: string().min(1),
  url: string().url().optional().or(literal("")),
  caption: string().optional(),
  image: any().transform(value => value || new File([], "")),
  wishlistIds: array(number()),
  price: string().or(number()).optional(),
  currency: string().optional()
}).transform((data) => {
  if (!data.price) return { ...data, currency: "" }
  return { ...data, price: removeSeparator(String(data.price)) }
})
